<script setup>
// Главный пункт меню «OVVA» — открывает панель управления OVVA (embed.ejs с
// бэкенда) в iframe. URL берём из зарегистрированного Dashboard App (в БД, с
// ключом) — чтобы НЕ хранить EMBED_TOKEN в бандле фронта.
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useMapGetter } from 'dashboard/composables/store';
import { getOvvaPat } from 'dashboard/composables/useOvvaBackend';

const store = useStore();
const records = useMapGetter('dashboardApps/getRecords');
const currentUser = useMapGetter('getCurrentUser');
const currentRole = useMapGetter('getCurrentRole');
const frame = ref(null);

const ovvaUrl = computed(() => {
  const app = (records.value || []).find(a =>
    (a.title || '').toUpperCase().includes('OVVA')
  );
  return app?.content?.[0]?.url || '';
});

// Панель внутри iframe запрашивает контекст сообщением
// `chatwoot-dashboard-app:fetch-info` и ждёт ответа `appContext` — по нему она
// узнаёт роль зрителя и прячет админские вкладки от оператора.
//
// Отвечал на этот запрос только Frame.vue — обёртка приложений внутри диалога.
// Здесь панель открыта отдельной страницей, и отвечать было некому: роль не
// приходила, панель считала зрителя администратором (currentUserRole === null
// трактуется как админ) и показывала оператору все вкладки.
const frameOrigin = computed(() => {
  try {
    return new URL(ovvaUrl.value, window.location.href).origin;
  } catch (e) {
    return '';
  }
});

const sendContext = () => {
  const win = frame.value?.contentWindow;
  if (!win || !frameOrigin.value) return;
  win.postMessage(
    JSON.stringify({
      event: 'appContext',
      data: {
        currentAgent: {
          id: currentUser.value?.id,
          name: currentUser.value?.name,
          email: currentUser.value?.email,
          role: currentRole.value,
        },
        ovvaPat: getOvvaPat(),
      },
    }),
    frameOrigin.value
  );
};

const onMessage = event => {
  if (event.source !== frame.value?.contentWindow) return;
  if (event.data === 'chatwoot-dashboard-app:fetch-info') sendContext();
};

onMounted(() => {
  store.dispatch('dashboardApps/get');
  window.addEventListener('message', onMessage);
});

onUnmounted(() => {
  window.removeEventListener('message', onMessage);
});
</script>

<template>
  <div class="flex flex-col w-full h-full bg-n-background">
    <iframe
      v-if="ovvaUrl"
      ref="frame"
      :src="ovvaUrl"
      class="flex-grow w-full border-0"
      title="OVVA"
      allow="clipboard-read; clipboard-write"
      @load="sendContext"
    />
    <div v-else class="p-8 text-sm text-n-slate-11">
      Панель OVVA не настроена. Зарегистрируйте Dashboard App с названием «OVVA» в
      этом аккаунте (Настройки → Интеграции → Dashboard Apps).
    </div>
  </div>
</template>
